module.exports = __webpack_public_path__ + "static/media/instructivosc8.48b3286a.png";